module.exports = __webpack_public_path__ + "static/img/204.d94b856.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/204.png
// module id = 503
// module chunks = 3